"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyAttackWithDamage = void 0;
const mkEmptyResult = () => ({
    attack: {
        hit: false,
        crit: true,
        roll: 0,
        total: 0
    },
    damages: []
});
function applyAttackWithDamage(args) {
    const result = mkEmptyResult();
    const { abilityKey, attackerId, attackType, targetId, toApply, onBeforeDamage, onMiss, onHit, onHitOrMiss } = args;
    let { sequence } = args;
    sequence = sequence.pushSequence("sequential");
    const { attack } = this.applyAttack({
        sequence,
        attackerId,
        type: attackType,
        targetId,
        abilityKey,
        onBeforeDamage: (sequence) => {
            onBeforeDamage === null || onBeforeDamage === void 0 ? void 0 : onBeforeDamage(sequence);
        },
        onHit: (sequence, _, attack) => {
            const { applied } = this.applyAttackDamages({
                attackType,
                attackerId,
                targetId,
                isCrit: attack.crit,
                toApply,
                sequence,
            });
            result.damages = applied;
            onHit === null || onHit === void 0 ? void 0 : onHit(sequence, attack, applied);
            onHitOrMiss === null || onHitOrMiss === void 0 ? void 0 : onHitOrMiss(sequence, attack);
        },
        onMiss(sequence, _, attack) {
            onMiss === null || onMiss === void 0 ? void 0 : onMiss(sequence, attack);
            onHitOrMiss === null || onHitOrMiss === void 0 ? void 0 : onHitOrMiss(sequence, attack);
        }
    });
    result.attack = attack;
    return result;
}
exports.applyAttackWithDamage = applyAttackWithDamage;
